var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletDynamic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8239_42621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0.5H0V48.5H48V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8239_42621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.175 7.32412C19.4014 5.49487 18.1198 4.52745 16.6003 4.32431C16.2798 4.28145 15.9564 4.26451 15.6332 4.27363C13.4219 4.33605 11.5368 6.03292 7.7665 9.42666C2.88761 13.8183 0.448154 16.0141 0.0686928 18.8505C0.0132252 19.2652 -0.00870979 19.6837 0.00310174 20.1018C0.0246055 20.8631 0.195958 21.5944 0.518679 22.3499C0.754613 22.7701 1.00863 23.0367 1.26172 23.1741C1.62564 23.3718 2.92922 23.733 6.11571 20.8599C7.78483 19.3549 11.7354 15.8054 16.016 11.9596L16.0177 11.958C17.7255 10.4235 19.4859 8.8419 21.175 7.32412ZM3.00626 26.2054C3.3217 26.6137 3.58274 26.9353 3.6875 27.037L3.7255 27.0037L3.68702 27.0383L11.8497 36.1748C16.8753 41.8 19.3881 44.6125 22.6992 44.804C26.0102 44.9953 28.8303 42.4909 34.4709 37.4821L41.4389 31.2942C45.7185 27.494 47.8581 25.5939 47.9933 23.0891C48.1286 20.5844 46.2058 18.465 42.3605 14.2265L42.3603 14.2264L39.4538 11.0226C35.6607 6.84186 33.7644 4.75149 31.2843 4.62419C29.4663 4.53088 27.8522 5.51915 25.4647 7.53884C23.1293 9.63812 20.52 11.9824 18.0243 14.2247L18.0231 14.2258C13.7455 18.0692 9.80158 21.6124 8.14291 23.1082C6.2545 24.8108 4.54119 25.8481 3.00626 26.2054Z",
    fill: "#4779FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDynamic);
export default __webpack_public_path__ + "static/media/wallet-dynamic.099aa401d7ab2b377055bd76d5c31d78.svg";
export { ForwardRef as ReactComponent };